/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_Upgrade_FailedInputs */



/**
* | output |
* | --- |
* | "Upgrade failed." |
*
* @param {Sub_Dashboard_Upgrade_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_upgrade_failed = /** @type {((inputs?: Sub_Dashboard_Upgrade_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Upgrade_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upgrade fehlgeschlagen.")
	return /** @type {LocalizedString} */ ("Upgrade failed.")
});